/* TU thumbnail drift (owner, 16 Sep 2026; smoothed the same day).
   When the gallery thumbnails overflow their strip, drift the strip slowly
   end to end and back, so thumbnails parked out of view get seen and the
   movement itself says "there is more here". Purely an attract mode: the
   first sign of intent (touch, click, wheel, key, focus, a variant change
   moving the active thumbnail) stops it for the life of the page, hover
   pauses it, and it only runs while the strip is on screen. Never runs under
   prefers-reduced-motion. The video row (tu-video-row) is untouched: this
   binds only to Dawn's .thumbnail-slider.

   Why a transform and not scrollLeft: scroll positions are whole CSS pixels,
   so a 16 px/s drift could only step once every three or four frames and
   looked jittery. The thumbnails are translated by a sub-pixel amount on the
   compositor instead, with the scroller parked at 0; the moment the reader
   takes over the offset is written into scrollLeft and the transform
   removed in the same frame, so their gesture starts where the picture is. */
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var SPEED = 18;        /* px per second at cruise */
  var EASE_ZONE = 70;    /* px over which it slows into and out of each end */
  var HOLD = 1600;       /* ms rest at each end before turning back */
  var LEAD = 1500;       /* ms before the first movement */

  function bind(comp) {
    if (comp.dataset.tuDrift === '1') return;
    comp.dataset.tuDrift = '1';
    var list = comp.querySelector('.thumbnail-list');
    if (!list) return;
    var items = function () { return list.querySelectorAll('.thumbnail-list__item'); };
    var pos = 0, dir = 1, raf = null, last = 0, holdUntil = 0;
    var running = false, stopped = false, seen = false, applied = false;

    function overflow() { return list.scrollWidth - list.clientWidth > 8; }
    function apply(x) {
      var t = x ? 'translate3d(' + (-x).toFixed(3) + 'px,0,0)' : '';
      var els = items();
      for (var i = 0; i < els.length; i++) els[i].style.transform = t;
      applied = !!x;
    }
    function handover() {
      /* move the picture into the real scroller, then drop the transform */
      if (!applied) return;
      var snap = list.style.scrollSnapType;
      list.style.scrollSnapType = 'none';
      list.scrollLeft = Math.round(pos);
      apply(0);
      list.style.scrollSnapType = snap;
    }
    function step(ts) {
      if (stopped || !running) return;
      if (!last) last = ts;
      var dt = Math.min(ts - last, 50); last = ts;
      if (ts >= holdUntil) {
        var max = list.scrollWidth - list.clientWidth;
        var toEnd = dir > 0 ? max - pos : pos;
        var k = Math.min(toEnd / EASE_ZONE, 1);          /* slow into the ends */
        var v = SPEED * (0.15 + 0.85 * k * (2 - k));     /* ease-out curve, never below 15% */
        pos += dir * v * dt / 1000;
        if (pos >= max) { pos = max; dir = -1; holdUntil = ts + HOLD; }
        else if (pos <= 0) { pos = 0; dir = 1; holdUntil = ts + HOLD; }
        apply(pos);
      }
      raf = requestAnimationFrame(step);
    }
    function start() {
      if (stopped || running || !overflow()) return;
      running = true; last = 0;
      if (!applied) { pos = list.scrollLeft; list.scrollLeft = 0; apply(pos); }
      holdUntil = performance.now() + (seen ? 400 : LEAD); seen = true;
      raf = requestAnimationFrame(step);
    }
    function pause() { running = false; if (raf) cancelAnimationFrame(raf); raf = null; }
    function stop() { stopped = true; pause(); handover(); }

    ['pointerdown', 'touchstart', 'wheel', 'keydown', 'focusin'].forEach(function (ev) {
      comp.addEventListener(ev, stop, { passive: true });
    });
    /* a real scroll from anywhere (trackpad, Dawn's arrows) is intent too */
    list.addEventListener('scroll', function () { if (running || applied) stop(); }, { passive: true });
    comp.addEventListener('mouseenter', pause);
    comp.addEventListener('mouseleave', function () { start(); });
    /* Dawn moves aria-current when a variant swap or thumbnail click changes
       the active media: the reader is steering, so stand down. */
    var mo = new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        if (muts[i].attributeName === 'aria-current' && muts[i].target.getAttribute('aria-current') === 'true'
            && muts[i].oldValue !== 'true') { stop(); return; }
      }
    });
    mo.observe(list, { attributes: true, subtree: true, attributeFilter: ['aria-current'], attributeOldValue: true });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) start(); else pause(); });
      }, { threshold: 0.6 }).observe(comp);
    } else {
      start();
    }
  }
  function init() { document.querySelectorAll('slider-component.thumbnail-slider').forEach(bind); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
